"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function CardMedia({ aspectRatio, children, className, exdent, inset, src, ...props }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('usa-card__media', aspectRatio && `usa-card__media--fix-aspect add-aspect-${aspectRatio}`, exdent && 'usa-card__media--exdent', inset && 'usa-card__media--inset', className), ...props, children: (0, jsx_runtime_1.jsx)("div", { className: "usa-card__img", children: (0, jsx_runtime_1.jsx)("img", { src: src, alt: children }) }) }));
}
exports.default = CardMedia;
